import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Spinner from "@atlaskit/spinner";

import { useRoutes } from "@/components/fastshift/src/common/hooks";

export const RedirectToSelectionPage: React.FC = () => {
    const navigate = useNavigate();
    const { paths } = useRoutes();
    useEffect(() => {
        const selectionPageUrl = paths.selection;
        navigate(selectionPageUrl);
    }, [navigate]);

    return <Spinner interactionName="load" label="Loading" />;
};
